/**
 * Footer component will be used to display footer on all the pages.
 */
import globals from '../globals';
import mobileMixin from '../mixins/mobile-mixin';

export default {
  name: 'vx-footer-section',
  components: {},
  props: {
    footerData: {
      type: Object,
      required: true,
    },
    copyrightText: {
      type: String,
    },
    isCheckoutFooter: {
      type: Boolean,
      required: true,
    },
    isHomePage: {
      type: Boolean,
      required: false,
    },
  },
  mixins: [mobileMixin],
  data() {
    return {
      globals,
      socialLinks: {
        facebook: '',
        pinterest: '',
        linkedin: '',
        youtube: '',
        twitter: '',
        instagram: '',
        snapchat: '',
        socialText: '',
      },
      footerColumnLength: 4,
      footerDataLength: this.footerData.columns.length,
    };
  },
  computed: {
    filteredFooterData() {
      let filteredFooterData = [];
      if (this.isCheckoutFooter) {
        filteredFooterData = this.footerData.columns;
      } else {
        filteredFooterData = this.footerData.columns.slice(
          0,
          this.footerDataLength - 1,
        );
      }
      return filteredFooterData;
    },
  },
  mounted() {
    const footerHeight = document.getElementsByClassName('footer-section')[0]
      .offsetHeight;
    this.$root.$emit('footer-height', footerHeight);
  },
  methods: {
    /**
     * In mobile mode - Handling accordion expand and collapse.
     * Setting aria labels for ADA purpose.
     * @param {*} event
     */
    toggle(event) {
      if (!this.isCheckoutFooter) {
        event.currentTarget.parentElement.classList.toggle('active');
        if (this.isTablet()) {
          if (
            event.currentTarget.children[0].classList.contains(
              'icon-chevron-down',
            )
          ) {
            event.currentTarget.children[0].classList.remove(
              'icon-chevron-down',
            );
            event.currentTarget.children[0].classList.add('icon-chevron-up');
            event.target.setAttribute('aria-expanded', true);
            event.target.setAttribute('aria-label', 'expanded');
          } else {
            event.currentTarget.children[0].classList.remove('icon-chevron-up');
            event.currentTarget.children[0].classList.add('icon-chevron-down');
            event.target.setAttribute('aria-expanded', false);
            event.target.setAttribute('aria-label', 'collapsed');
          }
        }
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/common/vx-footer-section/vx-footer-section.js